// Developer/admin-supplied video assets.
// NOTE: There is intentionally NO visitor-facing video upload feature. These
// assets are placed by a developer/admin into /public/videos (or any URL) and
// referenced below.
//
// SIZE GUARDRAILS:
//   - Hero background loop: compress to < 5 MB  (HERO_MAX_MB)
//   - About founder clip:   compress to < 15 MB (ABOUT_MAX_MB)
//
// LIMITATION (compression): Because there is no browser upload flow, compression
// is NOT performed client-side at runtime — it is the developer's responsibility
// to compress assets before adding them here. As a safeguard, the video
// components run a dev-time HEAD size check and console.warn if a served file
// exceeds its guardrail (see warnIfOversize below).
//
// To enable a video, uncomment/add sources. Order matters: put .webm first
// (smaller) and .mp4 as the broad-compatibility fallback.

export const HERO_POSTER =
  "https://static.prod-images.emergentagent.com/jobs/37b69393-8105-4850-9250-e296ccd14506/images/379ce73931d09a7b643ad109c0e6411ef980ba20d97ca66cc9b1710c88948f5f.jpeg";

// heroVideo — served from /public/assets. WebM first (smaller), MP4 fallback for Safari.
// GUARDRAIL: keep the production video under 5 MB and ideally an 8–12s seamless loop.
// The WebM here is ~3.8 MB (used by most browsers); the MP4 fallback is larger
// (~12 MB, Safari only) — re-encode if you need it smaller.
export const HERO_VIDEO = "/assets/hero-video.webm";
export const HERO_VIDEO_FALLBACK = "/assets/hero-video.mp4";
export const HERO_MAX_MB = 5;

export const ABOUT_POSTER = null;
export const ABOUT_VIDEO_SOURCES = [
  // { src: "/videos/founder.webm", type: "video/webm" },
  // { src: "/videos/founder.mp4", type: "video/mp4" },
];
export const ABOUT_MAX_MB = 15;

// Dev-time guardrail check: warns (does not block) if a served asset exceeds size.
export async function warnIfOversize(sources, maxMb) {
  if (process.env.NODE_ENV === "production") return;
  for (const s of sources) {
    try {
      const res = await fetch(s.src, { method: "HEAD" });
      const len = Number(res.headers.get("content-length"));
      if (len && len > maxMb * 1024 * 1024) {
        // eslint-disable-next-line no-console
        console.warn(
          `[media guardrail] ${s.src} is ${(len / 1048576).toFixed(1)} MB, exceeds the ${maxMb} MB limit. Please compress before shipping.`
        );
      }
    } catch {
      /* asset may not exist yet — ignore */
    }
  }
}
